export default __webpack_public_path__ + "images/HE.5aee3ee.png";